// @ts-nocheck
export default {
  es: {
    // Memberships section
    MEMBERSHIPS_SECTION_TITLE: 'Elige tu membresía Premium preferida',
    MEMBERSHIPS_SECTION_TITLE_PROMO: 'Elige tus planes a precio de aniversario',
    MEMBERSHIPS_SECTION_NOTE: 'Nuestras membresías son autorenovables',
    MEMBERSHIP_SECTION_TOTAL_ACCESS: 'Acceso total',
    MEMBERSHIPS_SECTION_FEATURE_1: 'Acceso a todo el catálogo',
    MEMBERSHIPS_SECTION_FEATURE_2: 'Acceso a las carreras',
    MEMBERSHIPS_SECTION_FEATURE_3: 'Cursos Premium',
    MEMBERSHIPS_SECTION_FEATURE_4: 'Mentoría personalizada',
    MEMBERSHIPS_SECTION_FEATURE_5: 'Diplomas físicos en carreras',
    MEMBERSHIPS_SECTION_FEATURE_6: 'Acceso a Skill IQ',
    MEMBERSHIPS_SECTION_FEATURE_7: 'Obtén una, regala una',
    MEMBERSHIPS_SECTION_BUTTON_1: 'Empezar mi plan',
    MEMBERSHIPS_SECTION_BUTTON_2: 'Programa una demo',
    MEMBERSHIPS_SECTION_BUTTON_3: 'Empezar ahora',
    MEMBERSHIPS_SECTION_ENTERPRISE_1:
      '¿Eres estudiante universitario o de instituto? Tenemos',
    MEMBERSHIPS_SECTION_ENTERPRISE_2: 'un plan especial para ti.',
    MEMBERSHIP_SECTION_YEARLY: 'Pago único anual de {{yearlyPrice}}',
    MEMBERSHIP_SECTION_MONTHLY: 'Cobro mensual',
    MEMBERSHIP_SECTION_MAX_MEMBERS:
      'Compártelo con {{licences}} persona{{addedPlural}}',

    RETRY: 'Reintentar',
    BECOME_PREMIUM: 'Aprovecha ya',
    BECOME_PREMIUM_2: 'Aprovecha ya',
    BECOME_PREMIUM_DESCRIPTION: '¡Accede a todo con rebajas!',
    STICKY_FORM_CONTACT: 'Deja tus datos y conversa con un asesor',
    STICKY_FORM_CONTACT_BTN_LABEL: 'Quiero que me contacten',
    PREMIUM_FOR_TWO: '¡Ahora Premium es para dos!',
    // Membership promo banner
    GIFT_MEMBERSHIP_BANNER_MESSAGE:
      'Solo por 7 días, compra una membresía premium y obtén un acceso adicional',
    GIFT_MEMBERSHIP_BANNER_SHORT_MESSAGE:
      'Solo por 7 días, compra una membresía premium y obtén un acceso adicional',

    ENDS_IN: 'Termina en ',
    OFFER_ENDS_IN: 'Precio especial: termina en ',
    POPULAR: 'Más comprado',
    INDIVIDUAL: 'Individual',
    DUO: 'Dúo',
    FAMILY: 'Familiar',

    TOTAL_ACCOUNTS_FAMILY: 'Hasta 4 Cuentas Premium',
    TOTAL_ACCOUNTS_DUO: '2 Cuentas Premium',
  },
};
